/*
THIS FILE IS DUPLICATED IN MULTIPLE PLACES! Make sure they stay the same.
- dashboard
- public
 */
// Except this line is different:
import Cookies from 'js-cookie'

/*
Strategy:
- we want to share cookies across multiple subdomains (dashboard, support, stats) of the base domain (goodnature.co.nz,
  test.goodnature.co.nz, etc)
- so we set the cookie's domain to the base domain
- BUT when you read a cookie, you can't specify which domain it comes from. This means test.goodnature.co.nz
  also picks up on cookies from goodnature.co.nz, which is also visible to it, and we get the wrong cookie.
- So: we prefix non-production cookie names with their domain!
 */

export let baseDomain
for (let d of ["goodnature.co.nz", "test.goodnature.co.nz", "gn.i"]) {
    if (location.host.match(`\\b${d}\\b`)) {
        baseDomain = d
    }
}
console.log("cookieDomain", baseDomain)

export const baseUrlForHost = function (host) {
    return `${location.protocol}//${host}.${baseDomain}`
}

function cookieName(key) {
    return baseDomain === "goodnature.co.nz" ? key : `${baseDomain}.${key}`.replaceAll(".", "_")
}

export const getPersistentValue = function (key) {
    return Cookies.get(cookieName(key))
}

export const setPersistentValue = function (key, value) {
    Cookies.set(cookieName(key), value, {domain: baseDomain, expires: 30})
}

export const deletePersistentValue = function (key) {
    return Cookies.remove(cookieName(key), {domain: baseDomain})
}

export const getSessionToken = () => {
    return getPersistentValue("dashboard-session")
}

export const setSessionToken = (token) => {
    setPersistentValue("dashboard-session", token)
}

export const deleteSessionToken = () => {
    deletePersistentValue("dashboard-session")
}

export const getAuthorizationHeader = () => {
    return {
        headers: {
            'X-Chirp-Token': getSessionToken()
        },
    }
}

export const isLoggedIn = () => {
    return !!getSessionToken()
}


// WEBPACK FOOTER //
// ./src/utils/session.js